<!--
  A collapsable block, usually for "advanced usage" block
-->

<template>
  <div>
    <el-collapse-transition>
      <span v-show="!forced"
        class="el-collapsable--title"
        @click.stop="handleActivate">
        <slot name="title">{{ title }}</slot>&nbsp;
        <i class="el-collapse-item__arrow el-icon-arrow-right"
          :class="{'is-active': value}"></i>
      </span>
    </el-collapse-transition>
    <el-collapse-transition>
      <div v-show="value || forced">
        <slot></slot>
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  name: 'ElCollapsable',
  props: {
    title: {
      type: String,
      default: 'Advanced usage',
    },
    value: Boolean,
    forced: Boolean,
  },
  watch: {
    forced (val) {
      if (val && !this.value) this.$emit('input', true)
    },
  },
  methods: {
    handleActivate () {
      if (!this.forced) this.$emit('input', !this.value)
    },
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  .el-collapsable--title {
    font-size: $--font-size-base;
    color: $--color-info;
    cursor: pointer;
  }
</style>
